import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import Home from './pages/Home';
import AMIDetails from './pages/AMIDetails';
import AccountDetails from './pages/AccountDetails';
import Search from './pages/Search';
import Accounts from './pages/Accounts';
import Hashes from './pages/Hashes';
import Timestamps from './pages/Timestamps';
import HashResults from './pages/HashResults';
import FAQ from './pages/FAQ';
import DailyStats from './pages/DailyStats';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f6f8fb',
      paper: '#ffffffcc',
    },
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/image/:imageId" element={<AMIDetails />} />
          <Route path="/account/:accountId" element={<AccountDetails />} />
          <Route path="/search" element={<Search />} />
          <Route path="/accounts" element={<Accounts />} />
          <Route path="/daily-stats" element={<DailyStats />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/image/:imageId/files/hashes" element={<Hashes />} />
          <Route path="/image/:imageId/files/timestamps" element={<Timestamps />} />
          <Route path="/hash/:hashId" element={<HashResults />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
